<template>
    <div class="comment__top">
        <div class="comment__top-left">
            <div class="comment__avatar">
                <img v-if="comment.user.avatar_url !== null" :src="comment.user.avatar_url" alt="">
                <span v-else>
                    {{usernameInsteadOfImage}}
                </span>
            </div>
        </div>
        <div class="comment__top-right">
            <div class="comment__top-right-inner">
                <div class="comment__author">
                    {{comment.user.username}}
                </div>
                <div class="comment__edit comment__edit--show-on-mobile" v-if="comment.wasEdited"></div>
            </div>
            <div class="comment__date">
                {{comment.createdAt}}
            </div>
            <div class="comment__edit comment__edit--not-for-mobile" v-if="comment.wasEdited"></div>
        </div>
        <PointerAnswerTo v-if="commentAnswerTo !== null" :comment="commentAnswerTo"/>
        <LikeBtn :comment="comment" :is-mobile="false"/>
    </div>
</template>

<script>
    import PointerAnswerTo from "VueApps/comments/components/comment/parts/PointerAnswerTo.vue";
    import LikeBtn from "VueApps/comments/components/comment/parts/LikeBtn.vue";
    import {isCommentShowing} from "VueApps/comments/services/commentStatusResolver";
    import {getUserAvatarText} from "VueApps/comments/services/getUserAvatarText";

    export default {
        name: "CommentHeader",
        components: {LikeBtn, PointerAnswerTo},
        props: {
            comment: {
                type: Object,
                required: true
            },
            commentAnswerTo: {
                type: Object,
                default: null,
            },
        },
        computed: {
            isCommentShowing: function () {
                return isCommentShowing(this.comment);
            },
            usernameInsteadOfImage: function () {
                return getUserAvatarText(this.comment.user.username);
            },
        },
    }
</script>

<style scoped>

</style>
